import { baseApi } from './baseApi';
import { buildListQueryParams } from '../utils/pagination';
import { runOptimisticCachedQueryPatches } from './queryCacheUtils';

export const productSubcategoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getProductSubcategories: builder.query({
      query: (args = {}) => ({
        url: '/api/product_subcategories',
        params: buildListQueryParams(args),
      }),
      providesTags: ['ProductSubcategories'],
    }),
    getProductSubcategoryById: builder.query({
      query: (id) => `/api/product_subcategories/${id}`,
      providesTags: (_result, _error, id) => [{ type: 'ProductSubcategories', id }],
    }),
    createProductSubcategory: builder.mutation({
      query: ({ name, product_category_id, status = true }) => ({
        url: '/api/product_subcategories',
        method: 'POST',
        body: {
          product_subcategory: {
            name,
            product_category_id,
            status,
          },
        },
      }),
      invalidatesTags: ['ProductSubcategories'],
    }),
    updateProductSubcategory: builder.mutation({
      query: ({ id, name, product_category_id, status = true }) => ({
        url: `/api/product_subcategories/${id}`,
        method: 'PUT',
        body: {
          product_subcategory: {
            name,
            product_category_id,
            status,
          },
        },
      }),
      invalidatesTags: (_result, _error, { id }) => [
        'ProductSubcategories',
        { type: 'ProductSubcategories', id },
      ],
    }),
    updateProductSubcategoryStatus: builder.mutation({
      query: ({ id, name, product_category_id, status }) => ({
        url: `/api/product_subcategories/${id}`,
        method: 'PUT',
        body: {
          product_subcategory: {
            name,
            product_category_id,
            status,
          },
        },
      }),
      async onQueryStarted({ id, status }, { dispatch, getState, queryFulfilled }) {
        await runOptimisticCachedQueryPatches({
          dispatch,
          getState,
          queryFulfilled,
          endpointName: 'getProductSubcategories',
          updateDraft: (draft) => {
            const list = draft?.data;
            if (!Array.isArray(list)) return;
            const row = list.find((c) => Number(c.id) === Number(id));
            if (row) row.status = status;
          },
        });
      },
    }),
  }),
});

export const {
  useGetProductSubcategoriesQuery,
  useGetProductSubcategoryByIdQuery,
  useCreateProductSubcategoryMutation,
  useUpdateProductSubcategoryMutation,
  useUpdateProductSubcategoryStatusMutation,
} = productSubcategoryApi;
